import React, {Component, useEffect, useState} from "react";
import {getUserCustomers, setAccountType} from "../../actions/UserActions";
import {connect} from "react-redux";
import {clearSessionPaymentMethods} from "../../reducers/PaymentReducer";
import {canImpersonate} from "../../selectors/PermissionSelectors";
import {User} from "../../interfaces/User";

interface UserImpersonateProps{
    impersonatedUserId?: string, 
    user: User,
    currentUser: User,
    canImpersonate: boolean,
    getUserCustomers: Function,
    clearSessionPaymentMethods: Function,
    setAccountType: Function,
}

function UserImpersonate(props: UserImpersonateProps) {
    const [isChecked, setIsChecked] = useState(false);

    useEffect(() => {
        const impersonatedUserId = props.impersonatedUserId;
        if (impersonatedUserId && impersonatedUserId === props.user.user_id) {
            setIsChecked(true);
        } else {
            setIsChecked(false);
        }

    }, [props.impersonatedUserId]);

    // componentWillReceiveProps(nextProps) {
    //     const currentRowUser = this.state.user;
    //     if (this.props !== nextProps) {
    //         if (currentRowUser.userId !== nextProps.impersonatedUserId) {
    //             this.setState({isChecked: false});
    //         }
    //     }
    // }

    function onCheckClick() {
        if (props.user.user_id !== props.impersonatedUserId) {
            props.getUserCustomers(props.user.user_id, true);
            props.setAccountType(props.user.primary_account_type_id);
            // setIsChecked(true);
        } else {
            props.getUserCustomers("", true);
            props.setAccountType(props.currentUser.primary_account_type_id);
            // setIsChecked(false);
        }
        props.clearSessionPaymentMethods();
    };

    return (
        <div>
            {props.canImpersonate && <input
              className="rounded-circle"
              type="checkbox"
              onChange={onCheckClick}
              checked={isChecked}
              id={props.user.user_id}
              name={props.user.user_id}
                // disabled={user.accounts.length <= 0}
            />}
        </div>
    );
}

export default connect<any, any, any, any>((state, props) => ({
    impersonatedUserId: state.user_options.impersonatedUserId,
    currentUser: state.default.currentUser,
    canImpersonate: canImpersonate(state)
}), {
    getUserCustomers,
    clearSessionPaymentMethods,
    setAccountType
})(UserImpersonate);
